<template>
  <div class="wrapper-book wh100p">
    <section class="section-navs df">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('book.createBook')}}</div>
      </div>
    </section>

    <section class="section-form">
      <div class="form _bf">
        <div class="row df-c-sb _borderbottom">
          <div class="label f-m _themecolor">{{$t('book.bookShop')}}</div>
          <div class="value h100p df-c-fe">
            <div class="f-m _themecolor">{{shop_x['name'+_lang]}}</div>
          </div>
        </div>
        <div class="row df-c-sb _borderbottom">
          <div class="label f-m _themecolor">{{$t('book.bookNumber')}}</div>
          <div class="value h100p df-c-fe" @click="inputNum">
            <div class="f-m _themecolor">{{formData.number}}</div>
          </div>
        </div>
        <div class="row df-c-sb _borderbottom">
          <div class="label f-m _themecolor">{{$t('book.bookTime')}}</div>
          <div class="value h100p df-c-fe" @click="inputTime">
            <div class="f-m _themecolor">{{formData.eatStartDate}}</div>
          </div>
        </div>
        <div class="row df-c-sb _borderbottom">
          <div class="label f-m _themecolor">{{$t('book.contract')}}</div>
          <div class="value h100p df-c-fe">
            <input class="f-m _themecolor input" type="text" v-model="formData.contactName" @focus="onFocus_forScan" @blur="onBlur_forScan" />
          </div>
        </div>
        <div class="row df-c-sb _borderbottom">
          <div class="label f-m _themecolor">{{$t('book.phoneNumber')}}</div>
          <div class="value h100p df-c-fe">
            <input class="f-m _themecolor input" type="text" v-model="formData.contactPhone" @focus="onFocus_forScan" @blur="onBlur_forScan" />
          </div>
        </div>
        <div class="row df-c-sb _borderbottom">
          <div class="label f-m _themecolor">{{$t('book.remark')}}</div>
          <div class="value h100p df-c-fe">
            <input class="f-m _themecolor input" type="text" v-model="formData.remark" @focus="onFocus_forScan" @blur="onBlur_forScan" />
          </div>
        </div>
        <div class="row df-c-sb _borderbottom" v-if="isShowBookWhole">
          <div class="label f-m _themecolor">{{$t('book.bookWhole')}}</div>
          <div class="value h100p df-c-fe">
            <el-switch active-color="#34C759" inactive-color="#d0d0d0" v-model="formData.bookWhole" />
          </div>
        </div>
      </div>
      <div class="btns df-c-ct">
        <div class="btn" :class="formData.eatStartDate===''?'whitebtn-l':'themebtn-l'" @click="submit">{{$t('book.book')}}</div>
      </div>
    </section>

    <DialogNum ref="DialogNum" :count.sync="formData.number" :min="1" :max="maxPeople" />
    <DialogTime ref="DialogTime" :count.sync="formData.eatStartDate" />
  </div>
</template>

<script>
import DialogNum from '@/components/DialogNum'
import DialogTime from './components/DialogTime'
export default {
  name: 'createBook',
  components: { DialogNum, DialogTime },
  data() {
    return {
      formData: {
        number: '',
        eatStartDate: '',
        contactName: '',
        contactPhone: '',
        remark: '',
        bookWhole: false,
      },
    }
  },
  computed: {
    isShowBookWhole() {
      return this.bookConfig_m.openShieldReserve || false
    },
    maxPeople() {
      return this.bookConfig_m.maxPeople || Infinity
    },
  },
  methods: {
    inputNum() {
      this.$refs.DialogNum.open()
    },
    inputTime() {
      this.$refs.DialogTime.open()
    },
    async submit() {
      const {
        number,
        eatStartDate,
        contactName,
        contactPhone,
        remark,
        bookWhole,
      } = this.formData

      if (!eatStartDate) {
        this.$message.warning(this.$t('book.bookTimeIsRequired'))
        return
      }

      const rD = {
        companyId: this.shop_x.companyId,
        shopId: this.currentShopId,
        number: Number(number),
        eatStartDate,
        contactName,
        contactPhone,
        remark,
      }
      rD.eatStartTime = new Date(eatStartDate).getTime()
      rD.bookType = bookWhole ? 2 : 1

      const _R = await this.newData('book', rD)
      // console.log(`%c_R:`, 'color: #00f;', _R)
      if (_R) {
        this.$message.success(this.$t('book.success'))
        this.$router.go(-1)
      }
    },

    initPage() {},
    clearPage() {
      this.formData = {
        number: '',
        eatStartDate: '',
        contactName: '',
        contactPhone: '',
        remark: '',
        bookWhole: false,
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initPage()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.clearPage()
    next()
  },
}
</script>

<style lang='scss' scoped>
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }
}
.section-form{
  .form{
    width: calc(100% - 40px);margin: 20px 20px;padding: 20px 40px;box-sizing: border-box;border-radius: 12px;
    .row{
      height: 56px;
      .label{width: 180px;}
      .value{
        flex: 1;
        .input{text-align: right;border: 0;flex: 1;}
      }
    }
  }
}
</style>